/**
 * sz-category-grid-limit.js
 * Limits the product grid to 2 rows with a toggleable "See all" / "Show less" button.
 *
 * Breakpoints match Impact theme's --product-list-items-per-row:
 *   <=699px  → 2/row → show 4  (2 rows)
 *   700-999  → 2/row → show 4  (2 rows)
 *   1000-1199→ 3/row → show 6  (2 rows, no sidebar filter)
 *   >=1200   → 5/row → show 10 (2 rows)
 *
 * CSS-first: products are hidden by CSS class on <product-list> at page load
 * (no CLS). JS manages the toggle and updates the limit on resize.
 */
(function () {
  function getLimit() {
    var w = window.innerWidth;
    if (w < 700) return 4;
    if (w < 1000) return 4;
    if (w < 1200) return 6;
    return 10;
  }

  function init() {
    var productList = document.querySelector('product-list.product-list');
    if (!productList) return;

    var totalItems = productList.children.length;
    if (totalItems <= getLimit()) {
      productList.classList.remove('sz-grid-limited');
      return;
    }

    // CSS hides overflow via .sz-grid-limited (set in CSS, no CLS).
    // JS sets the CSS custom property for the current limit.
    productList.classList.add('sz-grid-limited');
    productList.style.setProperty('--sz-grid-limit', getLimit());

    // Create toggle button
    var btn = document.createElement('button');
    btn.className = 'sz-see-all-btn';
    btn.textContent = 'See all products';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', productList.id || '');
    productList.parentNode.insertBefore(btn, productList.nextSibling);

    btn.addEventListener('click', function () {
      var isExpanded = productList.classList.contains('sz-grid-expanded');
      var limit = getLimit();
      var items = Array.prototype.slice.call(productList.children);

      if (isExpanded) {
        /* Collapse: stagger-out hidden items, then remove expanded */
        productList.classList.add('sz-grid-collapsing');
        items.forEach(function (item, i) {
          if (i >= limit) {
            item.style.animationDelay = ((i - limit) * 30) + 'ms';
          }
        });
        var collapseTime = Math.max(300, (items.length - limit) * 30 + 300);
        setTimeout(function () {
          productList.classList.remove('sz-grid-expanded', 'sz-grid-collapsing');
          items.forEach(function (item) { item.style.animationDelay = ''; });
          btn.textContent = 'See all products';
          btn.setAttribute('aria-expanded', 'false');
          productList.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, collapseTime);
      } else {
        /* Expand: show all, then stagger-in newly visible items */
        productList.classList.add('sz-grid-expanded', 'sz-grid-expanding');
        items.forEach(function (item, i) {
          if (i >= limit) {
            item.style.animationDelay = ((i - limit) * 50) + 'ms';
          }
        });
        var expandTime = Math.max(400, (items.length - limit) * 50 + 400);
        setTimeout(function () {
          productList.classList.remove('sz-grid-expanding');
          items.forEach(function (item) { item.style.animationDelay = ''; });
        }, expandTime);
        btn.textContent = 'Show less';
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    // Update limit on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newLimit = getLimit();
        var currentTotal = productList.children.length;
        productList.style.setProperty('--sz-grid-limit', newLimit);

        // If fewer items than limit, remove limiter entirely
        if (currentTotal <= newLimit) {
          productList.classList.remove('sz-grid-limited');
          btn.style.display = 'none';
        } else {
          productList.classList.add('sz-grid-limited');
          btn.style.display = '';
        }
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
